<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="acknow">
<p class="ct"><a class="xref" href="#/pppdealdie0005#toc">Acknowledgments</a></p>
<p class="pf">Deal and I would like to extend our heartfelt thanks to Professor Thomas A. Breslin, Stephen Lazarus, M.D., Eric Kurzweil, M.D., and Mitchell Kaplan for their help and advice on matters of medicine, Chinese history and customs, and international trade …</p>
<p>… and to Rhonda Kurzweil, James W. Hall, and Nat Sobel for their help in the shaping of this story.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-dealdie0006.vue?7292fea4